if (!customElements.get('scroll-aware-header')) {
  class ScrollAwareHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('[data-theme-header]');
      if (!this.header) return;

      this.section = this.header.closest('.shopify-section');
      this.hiddenClass = 'is-header-hidden';
      this.hideOnScroll = this.header.getAttribute('data-hide-on-scroll') === 'true';
      this.overlayHeader = this.header.getAttribute('data-overlay-header') === 'true';
      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.reveal = this.reveal.bind(this);

      this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mediaQuery.addEventListener('change', this.onResize);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.header.addEventListener('focusin', this.reveal);

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.mediaQuery?.removeEventListener('change', this.onResize);
      this.header?.removeEventListener('focusin', this.reveal);
    }

    headerHeight() {
      return this.header?.getBoundingClientRect().height || 0;
    }

    uiLocksHeader() {
      if (window.Shopify?.designMode) return true;

      const modals = window.Alpine?.store?.('modals');
      if (!modals) return false;

      return ['leftDrawer', 'rightDrawer', 'quickBuyDrawer', 'modal'].some(
        (slot) => modals[slot]?.open
      );
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    onResize() {
      this.update();
    }

    reveal() {
      this.header.classList.remove(this.hiddenClass);
      this.section?.classList.remove(this.hiddenClass);
    }

    updateContrast() {
      if (!this.overlayHeader) return;

      const hero = document.querySelector('#MainContent > .shopify-section');
      const headerHeight = this.headerHeight();

      if (!hero || !headerHeight) {
        this.header.style.setProperty('--header-contrast', '1');
        return;
      }

      const heroBottom = hero.getBoundingClientRect().bottom;
      let contrast = (headerHeight - heroBottom) / headerHeight;
      contrast = Math.min(1, Math.max(0, contrast));

      if (this.mediaQuery.matches) {
        contrast = contrast >= 0.5 ? 1 : 0;
      }

      this.header.style.setProperty('--header-contrast', contrast.toFixed(3));
    }

    updateVisibility() {
      if (!this.hideOnScroll) return;

      const currentY = Math.max(0, window.scrollY);
      const goingDown = currentY > this.lastScrollY;
      this.lastScrollY = currentY;

      if (this.mediaQuery.matches || this.uiLocksHeader() || currentY <= this.headerHeight()) {
        this.reveal();
        return;
      }

      this.header.classList.toggle(this.hiddenClass, goingDown);
      this.section?.classList.toggle(this.hiddenClass, goingDown);
    }

    update() {
      this.updateContrast();
      this.updateVisibility();
    }
  }

  customElements.define('scroll-aware-header', ScrollAwareHeader);
}
